/*
 * @Author: liuxiaoling 
 * @Date: 2021-02-26 16:30:07 
 * @Last Modified by: liuxiaoling
 * @Last Modified time: 2021-03-01 10:21:29
 * @description: Request for 浏览轨迹 
 */
import request from '@/utils/request'

// 用户首次发送消息，记录轨迹
export function startBrowseTracks (data) {
    return request({
        url: '/browse_tracks/chating/page',
        method: 'post',
        data
    })
}

// 轮询接口:记录轨迹
export function recordBrowseTracks (data) {
    return request({
        url: '/browse_tracks/current/page',
        method: 'post',
        data
    })
}

// 访客访问记录
export function recordBrowseVisit ({ chat_user_id, domain }) {
    return request({
        url: '/browse_tracks/visit/view',
        method: 'post',
        data: {
            chat_user_id,
            domain
        }
    })
}

// 着陆接口
export function recordLanding (data) {
    return request({
        url: '/chat/landing',
        method: 'post',
        data
    })
}

